<template>
  <v-row no-gutters align="center" justify="center">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="6">
          <v-card height="125" flat class="cardBorder">
            <v-card-title class="d-flex justify-center">Courtroom Hours</v-card-title>
            <v-card-title class="text-subtitle-1 d-flex justify-center pt-0"> Monday - Friday: 8:00 AM - 4:00 PM <br>Saturday: 8:00 AM - 12:00 PM</v-card-title>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card height="125" flat class="cardBorder ">
            <v-card-title class="d-flex justify-center">Clerk's office</v-card-title>
            <v-card-title class="text-subtitle-1 d-flex justify-center pt-0 pb-0">Clerk - Parking & Civil: Monday - Friday: 8:00 A.M. - 4:00 P.M.</v-card-title>
            <v-card-title class="text-subtitle-1 d-flex justify-center pt-0"> Clerk - Criminal & Traffic: Monday - Sunday: 24/7</v-card-title>
          </v-card>
        </v-col>
        <!-- <v-col cols="4">
          <v-card height="125" flat>
            <v-card-title class="d-flex justify-center">Clerk - Criminal & Traffic</v-card-title>
            <v-card-title class="text-subtitle-1 d-flex justify-center pt-0"> Monday - Sunday: 24/7</v-card-title>
          </v-card>
        </v-col> -->
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "languageBar",
  data() {
    return {
      languages: [
        { name: 'English', code: 'en' },
        { name: 'Spanish', code: 'es-US' },
      ]
    }
  },
  computed: {
    ...mapGetters(["getTouchCount", "getCurrentLanguage", "getLanguages", "getenableADA"]),
  },
  methods: {
    pullLanguage(code) {
      return this.languages.filter(lang => lang.code === code)[0].name
    },
    adaTracking() {
      this.$store.commit("setTouchRequest", {
        module: "General",
        action: "ADA",
        response: "ADA enabled",
        timeStamp: new Date(),
        requestType: "Touch",
      });
    },
    changeLanguage(language) {
      switch (language) {
        case "en":
          this.$store.commit("setTouchCount", this.getTouchCount + 1);
          this.$i18n.locale = "en";
          this.$store.commit("setCurrentLanguage", "en");
          this.$store.dispatch("avatarSpeak", "I am now speaking in english.");
          this.$store.dispatch('setDefaults')
          this.$store.dispatch("identifyAvatarLangCodes", "en");
          this.$store.commit("setSpeechRecognitionLanguage", "en-US")
          this.$store.commit("setTouchRequest", {
            module: "Language Bar",
            action: "Change Language",
            response: "Language changed to English",
            timeStamp: new Date(),
            requestType: "Touch",
          });
          break;
        case "es-US":
          this.$i18n.locale = "es";
          this.$store.commit("setCurrentLanguage", "es-US");
          this.$store.dispatch('avatarSpeak', 'Ahora estoy hablando en español.');
          this.$store.dispatch('setDefaultsSpanish')
          this.$store.dispatch("identifyAvatarLangCodes", "es-US");
          this.$store.commit("setSpeechRecognitionLanguage", "es-US")
          // Track the touch count and action performed.
          this.$store.commit("setTouchCount", this.getTouchCount + 1);
          this.$store.commit("setTouchRequest", {
            module: "Language Bar",
            action: "Change Language",
            response: "Language changed to Spanish",
            timeStamp: new Date(),
            requestType: "Touch",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.btnDim {
  width: 90%;
  padding-top: 15px;
  padding-bottom: 15px;
}

.cardBorder{
  border-right: 1px solid #000000;
  border-radius: 0px !important;
}
</style>